/**
 * component-sticky-promo-bar.js
 * Custom Element <sticky-promo-bar threshold="700">
 * Lot 2 Batch A — EDJ Shopify theme
 */
(function () {
  class StickyPromoBar extends HTMLElement {
    connectedCallback() {
      this._threshold = parseInt(this.getAttribute('threshold') || '700', 10);
      this._shown = false;

      // Listen on the nearest [data-scroll-container] ancestor, else window
      const scrollEl = this.closest('[data-scroll-container]');
      if (scrollEl) {
        this._scrollTarget = scrollEl;
        scrollEl.addEventListener('scroll', this._onScroll.bind(this), { passive: true });
      } else {
        this._scrollTarget = window;
        window.addEventListener('scroll', this._onScroll.bind(this), { passive: true });
      }
    }

    disconnectedCallback() {
      if (this._scrollTarget === window) {
        window.removeEventListener('scroll', this._onScroll.bind(this));
      } else if (this._scrollTarget) {
        this._scrollTarget.removeEventListener('scroll', this._onScroll.bind(this));
      }
    }

    _onScroll() {
      const scrollTop = this._scrollTarget === window
        ? (window.scrollY || document.documentElement.scrollTop)
        : this._scrollTarget.scrollTop;

      const shouldShow = scrollTop > this._threshold;
      if (shouldShow !== this._shown) {
        this._shown = shouldShow;
        if (shouldShow) {
          this.setAttribute('data-shown', '');
        } else {
          this.removeAttribute('data-shown');
        }
      }
    }
  }

  if (!customElements.get('sticky-promo-bar')) {
    customElements.define('sticky-promo-bar', StickyPromoBar);
  }
})();
